module.exports = __webpack_public_path__ + "img/good.f8bb2a15.png";